<template>
  <div class="lottery-record page">
    <van-nav-bar :title="$t('my.task_record') || 'Order Record'" class="custom-nav" :border="false">
      <template #left>
        <van-icon name="arrow-left" color="#f3c7a2" size="24" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main-content">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data') || 'No Data'" />
        
        <div v-else class="record-card" v-for="(item, index) in list" :key="index">
          <!-- 卡片头部：期数和彩种信息 -->
          <div class="card-header">
            <div class="lottery-info">
              <van-image class="lottery-icon" :src="item.ico">
                <template v-slot:loading>
                  <van-loading type="spinner" size="20" />
                </template>
              </van-image>
              <span class="lottery-name">{{ item.name }}</span>
              <span class="lottery-expect">{{ item.expect }}</span>
            </div>
            <div class="status-badge" :class="item.status === 1 ? 'success' : 'pending'">
              {{ item.status === 1 ? ($t('game_record.status_completed') || 'Completed') : ($t('game_record.status_processing') || 'Processing') }}
            </div>
          </div>

          <!-- 开奖结果区域 -->
          <div class="result-area" v-if="item.status === 1 && item.opencode">
            <div class="result-row">
              <span class="label">{{ $t("reservation.result") || 'Result' }}:</span>
              <div class="result-tags">
                <span class="tag-box">{{ calcSize(item.opencode) }}</span>
                <span class="tag-box">{{ calcDouble(item.opencode) }}</span>
              </div>
            </div>
          </div>

          <!-- 投注明细列表 -->
          <div class="bets-list" v-if="item.data && item.data.length > 0">
            <div class="bet-item" v-for="(bet, bIndex) in item.data" :key="bIndex">
              <div class="bet-info-row">
                <span class="bet-label">{{ $t("reservation.money") || 'Amount' }}: <span class="highlight-gold">{{ $money(bet.money) }}</span></span>
                <span class="bet-status" :class="{'win': bet.is_win === 1, 'lose': bet.is_win === 2}">
                  {{ bet.is_win === 1 ? ($t('lottery.profit') || 'Profit') : bet.is_win === 2 ? ($t('lottery.loss') || 'Loss') : bet.win_text }}
                </span>
              </div>
              <div class="bet-time-row">
                <span class="time-label">{{ $t("reservation.order_time") || 'Time' }}:</span>
                <span class="time-val">{{ bet.create_time }}</span>
              </div>
            </div>
          </div>

        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LotteryRecord',
  data() {
    return {
      isLoading: false,
      list: [],
      lang: 'en'
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getUserGameList();
      }, 500);
    },
    calcSize(opencode) {
      if (!opencode || opencode.length < 3) return '-';
      const sum = opencode[0] + opencode[1] + opencode[2];
      if (sum >= 11 && sum <= 18) {
        return this.lang === 'zh' ? '玫瑰' : this.lang === 'en' ? 'Rose' : this.lang === 'ja' ? 'ロケット' : '장미';
      } else if (sum >= 3 && sum <= 10) {
        return this.lang === 'zh' ? '百合' : this.lang === 'en' ? 'Lily' : this.lang === 'ja' ? 'ハート' : '백합';
      }
      return '-';
    },
    calcDouble(opencode) {
      if (!opencode || opencode.length < 3) return '-';
      const sum = opencode[0] + opencode[1] + opencode[2];
      if (sum % 2 === 0) {
        return this.lang === 'zh' ? '氣球' : this.lang === 'en' ? 'Balloon' : this.lang === 'ja' ? 'バラ' : '풍선';
      } else {
        return this.lang === 'zh' ? '煙花' : this.lang === 'en' ? 'Fireworks' : this.lang === 'ja' ? 'ヨット' : '불꽃놀이';
      }
    },
    getUserGameList() {
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data || [];
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      });
    }
  },
  created() {
    this.lang = localStorage.getItem("lang") || 'ja';
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserGameList();
    }
  }
};
</script>

<style lang="less" scoped>
.lottery-record {
  background-color: #1f1c1f;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 导航栏暗金风格 */
.custom-nav {
  background-color: #2b2b2b !important;
  border-bottom: 2px solid #766350;
}
::v-deep .custom-nav .van-nav-bar__title {
  color: #e6b98a !important;
  font-size: 36px;
}
::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0 !important;
}

.main-content {
  flex: 1;
  padding: 30px 20px;
  overflow-y: auto;
}

/* 卡片样式 */
.record-card {
  background: #2b2b2b;
  border: 2px solid #766350;
  border-radius: 20px;
  margin-bottom: 30px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px;
  border-bottom: 2px solid #3a3a3a;
  background: #242424;
}

.lottery-info {
  display: flex;
  align-items: center;
}

.lottery-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 2px solid #766350;
  margin-right: 20px;
}

.lottery-name {
  color: #f3c7a2;
  font-size: 32px;
  font-weight: bold;
  margin-right: 16px;
}

.lottery-expect {
  color: #999;
  font-size: 24px;
}

.status-badge {
  font-size: 24px;
  padding: 6px 16px;
  border-radius: 30px;
  font-weight: bold;
  
  &.success {
    background: rgba(7, 193, 96, 0.1);
    color: #07c160;
  }
  &.pending {
    background: rgba(243, 199, 162, 0.1);
    color: #f3c7a2;
  }
}

/* 开奖结果 */
.result-area {
  padding: 20px 30px;
  border-bottom: 2px dashed #3a3a3a;
}

.result-row {
  display: flex;
  align-items: center;
  
  .label {
    color: #999;
    font-size: 28px;
    margin-right: 20px;
  }
}

.result-tags {
  display: flex;
  gap: 20px;
}

.tag-box {
  background: linear-gradient(135deg, #766350, #4a3c31);
  color: #f3c7a2;
  padding: 8px 24px;
  border-radius: 12px;
  font-size: 26px;
  font-weight: bold;
  border: 1px solid #8e7a66;
}

/* 投注明细 */
.bets-list {
  padding: 10px 30px 20px;
}

.bet-item {
  padding: 20px 0;
  border-bottom: 1px solid #3a3a3a;
  
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
}

.bet-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  
  .bet-label {
    color: #ccc;
    font-size: 28px;
  }
  
  .highlight-gold {
    color: #f3c7a2;
    font-size: 32px;
    font-weight: bold;
    margin-left: 10px;
  }
  
  .bet-status {
    font-size: 26px;
    font-weight: bold;
    color: #999;
    
    &.win {
      color: #ff4d4f;
    }
    &.lose {
      color: #999;
    }
  }
}

.bet-time-row {
  display: flex;
  justify-content: space-between;
  color: #777;
  font-size: 24px;
}
</style>
